/* eslint-disable no-undef */
// -- Add dynamic elements to (currently) hard-coded payment calculator
// -- Show lowest price out of CH & FL
// -- Add promos
// -- Change 'sticky' price to lowest price
(async (window, document) => {
  async function getData(uri) {
    const response = await fetch(uri);
    const responseData = await response.json();
    return responseData;
  }

  function createNoPriceFallback(colour = 'red') {
    const colourClass = colour === 'white' ? 'text--white' : '';
    const noPriceFallbackArray = [
      `<a class="text--primary heading--3 js-calltracks ${colourClass}" href="tel:0330 178 1945">`,
      '<svg class="icon margin-right-5" style="width: 15px; height: 15px;">',
      '<use xlink:href="#primaryNavPhone"></use>',
      '</svg>',
      '<span data-calltracks-class="calltracks_vansdirect-central-call-centre-sales" data-default-number="443300400851">Call us</span>',
      '</a>',
    ];
    return noPriceFallbackArray.join('');
  }

  const leasePriceTarget = document.getElementById('lease-price');
  const stickyOverviewTarget = document.querySelector('.js-sticky-overview__price');
  const stickyOverviewPriceTarget = document.querySelector('.js-sticky-price');
  const priceGroupTarget = document.querySelector('.price-group__retail');
  const financeTermsTarget = document.querySelector('.js-finance-terms');

  const data = await getData(
    `/content/api/ajax_ecomm_services.p?Action=FinanceCalc&SpecRef=${vehicleRef.specRef}`,
  );

  // Display BCH price
  const bchMonthlyPayment = parseFloat(data?.Quote?.BCH?.MonthlyPayment, 10);
  const ch =
    typeof bchMonthlyPayment === 'number' &&
    !Number.isNaN(bchMonthlyPayment) &&
    bchMonthlyPayment !== 0
      ? Math.round(bchMonthlyPayment)
      : 0;

  if (ch === 0) {
    priceGroupTarget.innerHTML = createNoPriceFallback();
    priceGroupTarget.classList.remove('background-grey');
    financeTermsTarget.remove();
  } else {
    leasePriceTarget.innerHTML = `&pound;${ch}`;
  }

  // Display HP price
  const hpPriceTarget = document.getElementById('hp-price');
  const hpMonthlyPayment = parseFloat(data?.Quote?.HPAPR?.MonthlyPayment, 10);
  const hpAprTarget = document.getElementById('hp-apr');
  const hpDeposit = document.getElementById('hp-deposit');
  const hpTerm = document.getElementById('hp-contract-length');
  const hpContent = document.querySelector('.hp-price');
  const hpContentFallback = document.querySelector('.no-hp-price');

  if (hpMonthlyPayment === 0 || Number.isNaN(hpMonthlyPayment)) {
    hpContent.classList.add('hide__default');
    hpContentFallback.classList.remove('hide__default');
  } else {
    hpPriceTarget.innerHTML = `&pound;${Math.round(hpMonthlyPayment)}`;
    hpDeposit.innerHTML = `&pound;${Math.round(parseFloat(data?.Quote?.HPAPR?.MinDeposit, 10))}`;
    hpTerm.innerHTML = data?.Quote?.HPAPR?.Term;
    hpAprTarget.innerHTML = data?.Quote?.HPAPR?.APR;
  }

  // Add finance term variables to disclaimer
  if (ch !== 0) {
    const upfrontPaymentsTarget = document.getElementById('upfront-payments');
    const contractLengthTarget = document.getElementById('contract-length');
    const milesPerYearTarget = document.getElementById('miles-per-year');
    contractLengthTarget.innerHTML = data.Quote.BCH.Term;
    upfrontPaymentsTarget.innerHTML = data.Quote.BCH.UpFrontPayments;
    milesPerYearTarget.innerHTML = parseInt(data.Quote.AnnualMileage, 10).toLocaleString();
  }
  // Add BCH price to sticky overview
  if (ch === 0) {
    stickyOverviewTarget.innerHTML = createNoPriceFallback('white');
  } else {
    stickyOverviewPriceTarget.innerHTML = ch;
  }

  // Show/hide content based on radio switch
  function initRadioSwitch() {
    const radioSwitch = document.querySelectorAll('.switch-input');
    radioSwitch.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        document.querySelectorAll('.finance-content').forEach((el) => {
          el.classList.add('hide__default');
        });
        document.querySelector(`.${e.target.value}`).classList.remove('hide__default');
      });
    });
  }

  // initiate data classes on CTAs
  const leaseCtas = [
    'lease_click_request_a_quote',
    'lease_click_request_a_callback',
    'lease_click_call_now',
    'lease_click_request_a_quote_sticky',
    'lease_click_call_now_sticky',
  ];
  const buyCtas = [
    'buy_click_request_a_quote',
    'buy_click_request_a_callback',
    'buy_click_call_now',
    'buy_click_request_a_quote_sticky',
    'buy_click_call_now_sticky',
  ];

  const requestAQuoteButtons = document.querySelectorAll('.js-request-a-quote');

  function changeToLease() {
    const callNowButtons = document.querySelectorAll('.js-call-now');
    buyCtas.forEach((cta, i) => {
      document.querySelector(`.${cta}`).classList.add(leaseCtas[i]);
      document.querySelector(`.${cta}`).classList.remove(cta);
    });
    requestAQuoteButtons.forEach((button) => {
      const { href } = button;
      const url = new URL(href);
      url.searchParams.set('finType', 'lease');
      button.href = url.toString();
    });
    callNowButtons.forEach((button) => {
      button.classList.remove('abtest_call_buy');
      button.classList.add('abtest_call_lease');
    });
  }
  function changeToBuy() {
    const callNowButtons = document.querySelectorAll('.js-call-now');
    leaseCtas.forEach((cta, i) => {
      document.querySelector(`.${cta}`).classList.add(buyCtas[i]);
      document.querySelector(`.${cta}`).classList.remove(cta);
    });
    requestAQuoteButtons.forEach((button) => {
      const { href } = button;
      const url = new URL(href);
      url.searchParams.set('finType', 'buy');
      button.href = url.toString();
    });
    callNowButtons.forEach((button) => {
      button.classList.remove('abtest_call_lease');
      button.classList.add('abtest_call_buy');
    });
  }
  function initCtaDataClassesSwitching() {
    const headerCallUs = document.querySelector('.primary-nav__item--contact');
    headerCallUs.classList.add('lease_click_call_now');
    const radios = document.querySelectorAll('input[name="buyLeaseView"]');
    radios.forEach((radio) => {
      radio.addEventListener('change', (e) => {
        if (e.target.value === 'buy-content') {
          changeToBuy();
        } else {
          changeToLease();
        }
      });
    });
  }

  window.vm.onload(initCtaDataClassesSwitching);
  window.vm.onload(initRadioSwitch);
})(window, document);
